<div class="card">
  <div *ngIf="showHeader" class="position-relative card-header mt-1 bg-white">
    <div
      *ngIf="withPreviousButton"
      class="position-absolute fw-semibold mb-1 btn-retour"
      title="Retour"
      (click)="goBack()"
    >
      <i-feather name="arrow-left"></i-feather>
      <span class="ms-1">{{ goBackLabel }}</span>
    </div>

    <div
      *ngIf="withHomeButton"
      class="position-absolute fw-semibold mb-1 btn-retour"
      title="Accueil"
      (click)="goHome()"
    >
      <i-feather name="home"></i-feather>
    </div>

    <div class="card-title text-center">
      <h5>{{ titleWrapper }}</h5>
    </div>
  </div>
  <div class="card-body">
    <ng-content select="[body]"></ng-content>
  </div>
  <div *ngIf="showFooter" class="card-footer">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
